import { Box, Typography } from "@mui/material";
import React, { Fragment, useState } from "react";
import app from "../../assets/app.png";
import gmail from "../../assets/gmail.png";
import insta from "../../assets/insta.png";
import meta from "../../assets/meta.png";
import yout from "../../assets/yout.png";
import ArticleIcon from "@mui/icons-material/Article";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import InfoIcon from "@mui/icons-material/Info";
import StarIcon from "@mui/icons-material/Star";
import { useHistory } from "react-router-dom";
import TermsAndCondition from "../TermsAndCondition";
import About from "../About";

function BottomIcons({ homeViews }) {
  const [openTerms, setOpenTerms] = useState(false);
  const [openAbout, setOpenAbout] = useState(false);

  const handleTermsAndCondition = () => setOpenTerms(false);
  const handleCloseAbout = () => setOpenAbout(false);

  const history = useHistory();

  const displayCount = homeViews != null
    ? homeViews > 999 ? `${(homeViews / 1000).toFixed(1)}K` : homeViews
    : "—";

  return (
    <Fragment>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "center",
          margin: "10px 0px",
          padding: "0px 70px",
        }}
      >
        <div>
          <a className="bottom-icon-link" style={{ color: "white", textDecoration: "none", display: "flex" }} href={`https://wa.me/917293838383?text=Hello`}>
            <img src={app} alt="not found" width="25px" height="25px" />
          </a>
        </div>
        <div>
          <a className="bottom-icon-link" style={{ color: "white", textDecoration: "none", display: "flex" }} href="https://instagram.com/masterclickinfo?utm_source=qr&igshid=ZDc4ODBmNjlmNQ%3D%3D">
            <img src={insta} alt="not found" width="25px" height="25px" />
          </a>
        </div>
        <div>
          <a className="bottom-icon-link" style={{ color: "white", textDecoration: "none", display: "flex" }} href="https://www.facebook.com/profile.php?id=100094627446669&mibextid=ZbWKwL">
            <img src={meta} alt="not found" width="25px" height="25px" />
          </a>
        </div>
        <div>
          <a className="bottom-icon-link" style={{ color: "white", textDecoration: "none", display: "flex" }} href="https://www.youtube.com/@masterbooks6521/featured">
            <img src={yout} alt="not found" width="25px" height="25px" />
          </a>
        </div>
        <div>
          <a className="bottom-icon-link" style={{ color: "white", textDecoration: "none", display: "flex" }}>
            <img src={gmail} alt="not found" width="25px" height="25px" />
          </a>
        </div>
        {/* Home page view counter — same row as social icons, after Mail */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            backgroundColor: "rgba(255,255,255,0.15)",
            border: "1px solid rgba(255,255,255,0.3)",
            borderRadius: "8px",
            padding: "3px 7px",
            height: "25px",
            boxSizing: "border-box",
          }}
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.9)" strokeWidth="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
          <Typography sx={{ color: "rgba(255,255,255,0.9)", fontSize: "11px", fontWeight: 600, lineHeight: 1, whiteSpace: "nowrap" }}>
            {displayCount}
          </Typography>
        </Box>

        {/* Small Star Icon -> Used Items */}
        <Box
          onClick={() => history.push("/used-items")}
          title="Used Items"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            width: "26px",
            height: "26px",
            transition: "transform 0.2s ease",
            "&:hover": {
              transform: "scale(1.25)",
            },
          }}
        >
          <StarIcon sx={{ color: "#FFD700", fontSize: "22px", filter: "drop-shadow(0 0 4px rgba(255, 215, 0, 0.7))" }} />
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-evenly" }}>
        <div className="bottom_container_box footer-nav-btn" onClick={() => setOpenTerms(true)}>
          <ArticleIcon className="bottom_container_icon footer-nav-btn__icon" />{" "}
          <Typography className="bottom_container">Terms and condition</Typography>
        </div>
        <div className="bottom_container_box footer-nav-btn" onClick={() => history.push("/subscription-plan")}>
          <CardMembershipIcon className="bottom_container_icon footer-nav-btn__icon" />{" "}
          <Typography className="bottom_container">Subscription</Typography>
        </div>
        <div className="bottom_container_box footer-nav-btn" onClick={() => setOpenAbout(true)}>
          <InfoIcon className="bottom_container_icon footer-nav-btn__icon" />{" "}
          <Typography className="bottom_container">About Us</Typography>
        </div>
      </Box>
      {openTerms ? <TermsAndCondition open={openTerms} handleClose={handleTermsAndCondition} /> : null}
      {openAbout ? <About open={openAbout} handleClose={handleCloseAbout} /> : null}
    </Fragment>
  );
}

export default BottomIcons;
